import { Component, OnInit } from '@angular/core';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators, FormArray } from '@angular/forms';

import { AppConstants } from 'appshared/app-constants';

import { ReportsService } from '../../reports/reports.service';
import { MiscTools } from 'appshared/misc-tools';
import { UITools } from 'appshared/ui-tools';


@Component({
	selector: 'app-zen-customers-reports',
	templateUrl: './zen-customers-reports.component.html',
	styleUrls: ['./zen-customers-reports.component.scss']
})
export class ZenCustomersReportsComponent implements OnInit {
	ac = AppConstants;
	mt = MiscTools;
	ut = UITools;

	userByRoleForm: UntypedFormGroup;
	zmTypeChoices = [];

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private reportsService: ReportsService) {
	}

	// ****************************************************************
	ngOnInit(): void {
		this.zmTypeChoices = [];
		for (const zenMasterType of AppConstants.zenMasterTypes)
			this.zmTypeChoices.push({ value: zenMasterType, label: AppConstants.zenMasterTypeLabels[zenMasterType] });
	}

	// ****************************************************************
	async openReport(withCounts = false) {
		// let url = AppConstants.apiUrl + AppConstants.apiUrls.zencustomers + '/report';
		// if (withCounts) url += '?counts=yes';
		// else url += '?counts=no';
		// window.open(url, '_blank');

		let args = '';
		if (withCounts) args = 'counts=yes';
		await this.reportsService.runReport('ZenMasterSitesReport', args);
	}

	// ****************************************************************
	async prepUsersByRole() {
		if (!this.userByRoleForm) {
			const roleToFind: string = sessionStorage.getItem('last-zen-user-role-report-role') ? sessionStorage.getItem('last-zen-user-role-report-role') : '';

			let zenTypes: string[] = [];
			try {
				zenTypes = sessionStorage.getItem('last-zen-user-role-report-types') ? JSON.parse(sessionStorage.getItem('last-zen-user-role-report-types')) : [];
			} catch (ex: any) {
			} // try

			this.userByRoleForm = new UntypedFormGroup({
				roleToFind: new UntypedFormControl(roleToFind, [Validators.required]),
				zenTypes: new UntypedFormControl(zenTypes)
			});
		} // if

		UITools.clickButton('open-users-by-role-modal');
	}

	// ****************************************************************
	async runUsersByRole() {
		const roleToFind: string = this.userByRoleForm.value.roleToFind;
		const zenTypes: string[] = this.userByRoleForm.value.zenTypes;

		const accountTeam: string = 'yes';

		let url = AppConstants.apiUrl + AppConstants.apiUrls.zencustomers + '/users-by-role/' + encodeURIComponent(roleToFind)
			+ '?accountTeam=' + accountTeam;
		if (zenTypes && zenTypes.length > 0)
			url += '&zenTypes=' + encodeURIComponent(zenTypes.join(','));

		window.open(url, '_blank');
		UITools.clickButton('close-users-by-role-modal');

		sessionStorage.setItem('last-zen-user-role-report-role', roleToFind);
		sessionStorage.setItem('last-zen-user-role-report-types', JSON.stringify(zenTypes));
		this.userByRoleForm = null;
	}

}
